import React, { useState } from "react";
import "./index.css";
import { useHistory } from "react-router-dom";
import { Button, Col, Form, Input, message, Row, Select } from "antd";
import DatePicker from "react-datepicker2";
import I18n from "../../i18n";
import { ServiceLocater, Services } from "../../../service-locater";
import { DiscountRepository } from "../../../domain";
import { logger } from "../../../utils";
import { useAppDispatch } from "../../../application/store";
import { loadDiscounts } from "../../../application/discounts-slice";
import moment, { Moment } from "moment-jalaali";

const { useForm, Item } = Form;

export default function NewDiscount() {
  const [form] = useForm();
  const dispatch = useAppDispatch();
  const history = useHistory();
  const [isLoading, setIsLoading] = useState(false);
  const [expirationDate, setExpirationDate] = useState<Date>();
  const [phone, setPhone] = useState<string>();

  const submit = async () => {
    try {
      await form.validateFields();
      if (expirationDate === undefined) return;
      setIsLoading(true);
      const res = await ServiceLocater.get<DiscountRepository>(
        Services.DiscountRepository
      ).add(
        form.getFieldValue("discountType"),
        form.getFieldValue("amount"),
        form.getFieldValue("code"),
        expirationDate,
        phone
      );
      setIsLoading(false);
      res.fold(
        (_) => {
          message.error(I18n.general.networkError);
        },
        (_) => {
          message.success(I18n.discount.success);
          dispatch(loadDiscounts());
          history.push("/discounts");
        }
      );
    } catch (error) {
      logger.error(error);
    }
  };

  const min = new Date();
  min.setHours(0);
  min.setMinutes(0);
  min.setSeconds(0);
  min.setMilliseconds(0);

  return (
    <div style={{ margin: "16px 24px" }}>
      <Form
        form={form}
        layout="vertical"
        fields={[{ name: "phone", value: phone }]}
      >
        <Row>
          <Col lg={8} md={8} style={{ paddingLeft: 8 }}>
            <Item
              name="expirationDate"
              label={I18n.general.date}
              rules={[
                {
                  required: true,
                  validateTrigger: "onSubmit",
                  type: "date",
                },
              ]}
            >
              <DatePicker
                className={
                  "ant-input ant-input-lg ant-input-rtl" +
                  (isLoading ? " disbaled-datepicker" : "")
                }
                inputReadOnly={true}
                min={moment.utc(min.toISOString())}
                isGregorian={false}
                persianDigits={true}
                timePicker={false}
                value={moment.utc(expirationDate?.toISOString())}
                onChange={(date: Moment) => {
                  setExpirationDate(date.toDate());
                  form.setFields([{ name: "expirationDate", value: date }]);
                }}
              />
            </Item>
          </Col>
          <Col lg={8} md={8} style={{ padding: "0 8px" }}>
            <Item
              name="discountType"
              label={I18n.discount.discountType}
              rules={[
                {
                  required: true,
                  validateTrigger: "onSubmit",
                },
              ]}
            >
              <Select
                placeholder={I18n.discount.discountType}
                disabled={isLoading}
              >
                <Select.Option value="product">
                  {I18n.discount.product}
                </Select.Option>
                <Select.Option value="delivery">
                  {I18n.discount.delivery}
                </Select.Option>
              </Select>
            </Item>
          </Col>
          <Col lg={8} md={8} style={{ paddingRight: 8 }}>
            <Item
              name="amount"
              label={I18n.discount.amount}
              rules={[
                {
                  required: true,
                  validateTrigger: "onSubmit",
                  type: "integer",
                },
              ]}
            >
              <Input
                name="amount"
                maxLength={11}
                disabled={isLoading}
                onChange={(event) => {
                  try {
                    form.setFields([
                      { name: "amount", value: parseInt(event.target.value) },
                    ]);
                  } catch (error) {
                    logger.error(error);
                  }
                }}
              />
            </Item>
          </Col>
        </Row>
        <Row>
          <Col lg={8} md={8} style={{ paddingLeft: 8 }}>
            <Item
              name="code"
              label={I18n.discount.code}
              rules={[
                {
                  required: true,
                  validateTrigger: "onSubmit",
                },
              ]}
            >
              <Input name="code" maxLength={20} disabled={isLoading} />
            </Item>
          </Col>
          <Col lg={8} md={8} style={{ padding: "0 8px" }}>
            <Item
              name="phone"
              label={I18n.discount.userPhone}
              rules={[{ validateTrigger: "onSubmit", len: 11 }]}
            >
              <Input
                name="phone"
                maxLength={11}
                disabled={isLoading}
                allowClear
                inputMode="numeric"
                onChange={(v) => {
                  const value = v.target.value;
                  const numberRegex = /^[0-9\b]+$/;
                  if (value === "" || numberRegex.test(value)) {
                    setPhone(value);
                  }
                  form.setFields([
                    { name: "phone", value: phone ? phone : "" },
                  ]);
                }}
              />
            </Item>
          </Col>
        </Row>
        <Row>
          <Col lg={8} md={8} />
          <Col lg={8} md={8} style={{ padding: "0 8px" }}>
            <Item>
              <Button type="primary" block onClick={submit} loading={isLoading}>
                {I18n.general.submit}
              </Button>
            </Item>
          </Col>
          <Col lg={8} md={8} />
        </Row>
      </Form>
    </div>
  );
}
